const PAGE_URL_LOGIN = 'login'
const PAGE_URL_AFTER_REG = 'after_registration'
const PAGE_URL_CATALOG = 'catalog'
const PAGE_URL_ACTIVE = 'active'
const PAGE_URL_CART = 'cart'
const PAGE_URL_HISTORY = 'history'
const PAGE_URL_PROFILE = 'profile'
const PAGE_URL_RECEIVE_PAYMENT = 'receive_pay_response'
const PAGE_URL_LOGOUT = 'logout'

const SP_NEW_ORDER = 'new_order'

export {
  PAGE_URL_LOGIN,
  PAGE_URL_AFTER_REG,
  PAGE_URL_CATALOG,
  PAGE_URL_ACTIVE,
  PAGE_URL_CART,
  PAGE_URL_HISTORY,
  PAGE_URL_PROFILE,
  PAGE_URL_RECEIVE_PAYMENT,
  PAGE_URL_LOGOUT,
  //******/
  SP_NEW_ORDER,
}
